import { Box, Typography, Stack } from '@mui/material'
import { Clock24Regular, ChevronRight20Regular } from '@/components/Icon'
import { resolveWorkflowAppIcons } from '@/components/ConnectionApps/resolveWorkflowAppIcons'
import { WorkflowAppLogo } from '@/components/ConnectionApps/WorkflowAppLogo/WorkflowAppLogo'

export default function AutomationSummaryCard({ title, setup }) {
  const plan = setup?.semanticPlan
  const triggers = plan?.triggers ?? []
  const trigger = triggers[0]

  const words = (value) => {
    const val = value || ''
    const dict = { inbound: 'incoming', outbound: 'outgoing' }
    return dict[val] ?? String(val).replaceAll('_', ' ')
  }

  const triggerText = trigger
    ? `When an ${words(trigger.requested?.direction)} ${words(trigger.requested?.object_family)} is ${words(trigger.requested?.lifecycle)}`
    : '10:00 IST, Every Monday'

  // Extract unique tool slugs from cards
  const toolSlugs = [...new Set(setup?.cards?.map(c => c.tool_slug).filter(Boolean) || [])]
  const appIcons = resolveWorkflowAppIcons(toolSlugs)

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
      }}
    >
      <Box
        sx={{
          width: 48,
          height: 48,
          borderRadius: 2,
          bgcolor: '#feece5',
          color: '#e55c26',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
          border: '1px solid #fedbc9'
        }}
      >
        <Clock24Regular />
      </Box>
      <Box sx={{ minWidth: 0, flex: 1, display: 'flex', flexDirection: 'column' }}>
        <Typography variant="body2" color="text.secondary">
          {triggerText}
        </Typography>
        <Typography variant="body1" fontWeight={500} color="text.primary" noWrap>
          {title || 'Automation'}
        </Typography>
        <Stack direction="row" alignItems="center" spacing={0.5} sx={{ mt: 0.25, color: 'text.secondary' }}>
          <ChevronRight20Regular fontSize={16} />
          {appIcons.length > 0 ? (
            <Stack direction="row" spacing={0.5}>
              {appIcons.map((app, index) => (
                <Box key={index} sx={{ width: 20, height: 20, display: 'flex' }}>
                  <WorkflowAppLogo
                    iconUrl={app.iconUrl}
                    pillKind={app.pillKind}
                    displayName={app.displayName}
                  />
                </Box>
              ))}
            </Stack>
          ) : (
            <Stack direction="row" spacing={0.5}>
              <Box sx={{ width: 20, height: 20, borderRadius: 1, bgcolor: '#f0f0f0' }} />
              <Box sx={{ width: 20, height: 20, borderRadius: 1, bgcolor: '#f0f0f0' }} />
              <Box sx={{ width: 20, height: 20, borderRadius: 1, bgcolor: '#f0f0f0' }} />
            </Stack>
          )}
        </Stack>
      </Box>
    </Box>
  )
}
